module.exports = __webpack_public_path__ + "static/malaysia-map-ad045bab4eee4d7cd2c3f4006b839bb4.png";